<template>
    <div
        class="tab-pane sd-build"
        role="tab-panel"
        :id="build.id"
        :class="{'active': build.id == selectedBuild.id}"
    >
        <div class="sd-build__grid">
            <div class="sd-build--img">
                <img
                    :src="build.details.build.cover_image"
                    class="img-response"
                >
            </div>
            <div class="sd-build--content">
                <div class="sd-build--desc">
                    <h2 class="sd-build--desc__name text-upper text-bold m-a-0">{{ build.details.build.name }}</h2>
                    <p class="sd-build--desc__price text-green text-bold">${{ build.details.build.price }}</p>
                </div>
                <build-specs :build="build.details.build" />
            </div>
            <a
                href="#"
                @click.prevent="sendToConfigurator"
                class="btn btn-green m-y-md"
            >
                CONFIGURE BUILD
            </a>
        </div>
    </div>
</template>

<script>
import { isMobile } from "../../../../../util/helpers";
import BuildSpecs from "./build-specs.vue";
import CONSTANTS from "../../../../../config/constants.js";

export default {
    name: "PromoBuild",
    components: {
        BuildSpecs
    },
    props: {
        build: {
            type: Object,
            required: true
        },
        selectedBuild: {
            type: Object,
            required: true
        },
        promoId: {
            type: Number,
            required: true
        }
    },
    methods: {
        initCart() {
            this.$emit("is-loading", true);
            axios({
                url: `/sites/${CONSTANTS.SITES.LETSBLD}/promos/${this.promoId}/builds/${this.build.details.refurbished_builds_id}/init-cart`,
                method: "POST",
                headers: {
                    Token: CONFIG.SESSION
                }
            }).then(() => {
                this.processCheckout();
            }).catch(() => this.$emit("is-loading", false));
        },
        processCheckout() {
            const formData = new FormData();
            this.build.details.build.games.forEach((game, index) => {
                formData.append(`games[${index}]`, game.id);
            })

            axios({
                url: `/sites/${CONSTANTS.SITES.LETSBLD}/promos/${this.promoId}/checkout`,
                method: "POST",
                data: formData,
                headers: {
                    Token: CONFIG.SESSION
                }
            }).then(response => {
                window.location.href = response.data.checkout_url
            }).finally(() => {
                this.$emit("is-loading", false);
            })
        },
        sendToConfigurator(bldNumber, checkout = false) {
            axios({
                url: `/drafts/${this.build.details.refurbished_builds_id}/influencer`,
                method: "POST"
            }).then(response => {
                let step = isMobile() ? "step4-mobile" : "step4";

                if (checkout) {
                    step = "step5";
                }

                window.localStorage.setItem('session-draft', response.data);
                this.$store.dispatch('changeUserDraftId', response.data);
                this.$store.dispatch('changeDraftId', response.data);

                this.$router.push({
                    name: step,
                    query: {
                        price: 1000,
                        draft: response.data
                    }
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.sd-build {
    max-width: 100%;
    width: 1200px;
    margin: 0 auto;
    padding: 77px 15px;

    &__grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 15px;
        grid-template-rows: auto auto auto;
        justify-items: center;
    }

    &--img {
        grid-column: 1;
        grid-row: 1 / span 3;

        img {
            width: 500px;

            &.img-response {
                max-width: 100%;
            }
        }
    }

    &--content {
        max-width: 100%;
        width: 577px;
        grid-column: 2;
        grid-row: 1 / span 2;
    }

    &--desc {
        &__name {
            color: $purple;
            font-size: 48px;
            letter-spacing: 1.22px;
            line-height: 54px;
        }

        &__price {
            color: #595959;
            font-size: 20px;
            letter-spacing: 1.93px;
            line-height: 24px;
        }
    }

    .btn {
        grid-column: 2;
        grid-row: 3;
        justify-self: start;
    }
}

@media screen and (max-width: 990px) and (min-width: 320px) {
    .sd-build {
        padding: 54px 15px;

        &__grid {
            grid-template-columns: 100%;
            grid-column-gap: 15px;
            grid-template-rows: auto auto auto auto;
        }

        &--img {
            grid-column: 1;
            grid-row: 3;
        }

        &--content {
            max-width: 100%;
            width: 500px;
            grid-column: 1;
            grid-row: 1 / span 2;
        }
        &--desc {
            &__name {
                font-size: 40px;
                width: 257px;
                letter-spacing: 1.02px;
                line-height: 40px;
            }
        }
        .btn {
            width: 90%;
            grid-column: 1;
            grid-row: 4;
            justify-self: center;
        }
    }
}
</style>
